// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__9NFK1","feature":"image_feature__ZuYAV","square":"image_square__Emkm3","poster":"image_poster___ScRo","standard":"image_standard__nOzPB"};